import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface DepositionClientCellProps {
  /** The client (case client, else plaintiff, else deponent) from the API. */
  clientName: string;
  deponentName?: string | null;
  onClickCell?: () => void;
}

/**
 * Client cell for deposition summaries in My Documents (ZLAYT-1415).
 *
 * The row is listed under the client, with the deponent shown beneath it.
 * It is read-only on purpose: the inline rename on other rows would have
 * written the client's name into the deposition's deponent field.
 */
function DepositionClientCell({
  clientName,
  deponentName,
  onClickCell = () => {},
}: DepositionClientCellProps) {
  const showDeponent = !!deponentName && deponentName !== clientName;
  return (
    <Box
      onClick={onClickCell}
      sx={{
        display: 'flex',
        height: '100%',
        gap: '4px',
        alignItems: 'center',
        cursor: 'pointer',
      }}
    >
      <img src="/icons/document.svg" alt="Document" />
      <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <Typography variant="body2" noWrap title={clientName}>
          {clientName}
        </Typography>
        {showDeponent && (
          <Typography
            variant="caption"
            color="text.secondary"
            noWrap
            title={`Deponent: ${deponentName}`}
          >
            Deponent: {deponentName}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default DepositionClientCell;
